import React from "react";

export function Footer() {
    return (
        <div className="footer-container">
            <footer className="footerStyle">
                <div className="container footerDivStyle">
                    <p className="footerDivTextStyle underline">Contact Us</p>
                    <p className="footerDivTextStyle underline">Terms</p>
                    <p className="footerDivTextStyle underline">Privacy</p>
                    <p className="footerDivTextStyle"> &#169; Info 442: Group-G</p>
                </div>
            </footer>
        </div>
    )
}